module.exports = __webpack_public_path__ + "img/anvil_splash2.60c8478a.png";